import { defineComponent } from 'vue';
import { QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';

const RECAPTCHA_CLICK_CODE_BEHIND = {
    handlerSuffix: '_Click',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your click handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'recaptcha-dsgn',
    mixins: [BaseComponent],
    components: { QIcon },
    methods: {
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, RECAPTCHA_CLICK_CODE_BEHIND);
        },
    },
    render() {
        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    ...utils.getSize(this.controlData ? this.controlData.SizeOptions : null, this.parentType, this.$parent),
                }}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }}></div>
                <QIcon name="mdi-shield-check" color="primary" />
                <div style={{ fontSize: 'smaller', marginTop: '4px' }}>{this.controlData?.Name || this.type || 'Recaptcha'}</div>
            </div>
        );
    },
});
